import axiosInstance from "../../../api/axios";

export const getRoles = () => {
  return axiosInstance
    .get("/role/filtered")
    .then((response: any) => {
      return response.data;
    })
    .catch((error: any) => {
      console.log(error);
    });
};

export const getPermissions = () => {
  return axiosInstance
    .get("/permission")
    .then((response: any) => {
      return response.data;
    })
    .catch((error: any) => {
      console.log(error);
    });
};

export const getMenus = () => {
  return axiosInstance
    .get("/menu")
    .then((response: any) => {
      return response.data;
    })
    .catch((error: any) => {
      console.log(error);
    });
};
export const updateRole = async (role: any) => {
  const payload = {
    name: role.name,
    permissionIds: role.permissions,
    menuIds: role.menus,
  }
  return axiosInstance
    .patch(`/role/${role.id}`, payload)
    .then((response: any) => {
      return response.data;
    })
    .catch((error: any) => {
      console.log(error);
    });
}


export const addRole = async (role: any) => {
  const payload = {
    name: role.name,
    level: role.level,
    code: role.name,
    permissions:[],
    menus:[]
  };
  return axiosInstance
    .post('/role', payload)
    .then((response: any) => {
      return response.data;
    })
    .catch((error: any) => {
      console.log(error);
    });
};

